import Vue from 'vue'
import Store from 'store'

import ConfiguratorTablist from './ConfiguratorTablist.vue'

const el = '.nti-component--configurator-tablist'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                ConfiguratorTablist
            },
            template: '<ConfiguratorTablist />'
        })
    }
}

export default {
    render
}